import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Text from "../Text/Text";
import Dropdown from "../Dropdown/Dropdown";
import Button from "../Button/Button";
import LanguageIcon from "../Svg/Icons/Language";
import MenuButton from "./MenuButton";
var LangSelector = function(param) {
    var currentLang = param.currentLang, langs = param.langs, color = param.color, setLang = param.setLang, _param_dropdownPosition = param.dropdownPosition, dropdownPosition = _param_dropdownPosition === void 0 ? "bottom" : _param_dropdownPosition, _param_buttonScale = param.buttonScale, buttonScale = _param_buttonScale === void 0 ? "md" : _param_buttonScale, _param_hideLanguage = param.hideLanguage, hideLanguage = _param_hideLanguage === void 0 ? false : _param_hideLanguage;
    /*#__PURE__*/ return _jsx(Dropdown, {
        position: dropdownPosition,
        target: /*#__PURE__*/ _jsx(Button, {
            scale: buttonScale,
            variant: "text",
            startIcon: /*#__PURE__*/ _jsx(LanguageIcon, {
                color: color,
                width: "24px"
            }),
            children: !hideLanguage && /*#__PURE__*/ _jsx(Text, {
                color: color,
                children: currentLang === null || currentLang === void 0 ? void 0 : currentLang.toUpperCase()
            })
        }),
        children: langs.map(function(lang) {
            return /*#__PURE__*/ _jsx(MenuButton, {
                fullWidth: true,
                onClick: function() {
                    return setLang(lang);
                },
                // Safari fix
                style: {
                    minHeight: "32px",
                    height: "auto"
                },
                children: lang.language
            }, lang.locale);
        })
    });
};
export default /*#__PURE__*/ React.memo(LangSelector, function(prev, next) {
    return prev.currentLang === next.currentLang;
});
